<template>
  <!--
    nuxtjs jobs list 为未登录页面，登录页面请看vue技术栈
   -->
   <div class="jobs-list-main">
    <pc-navbar/>
    <div :style="{height: nonChrome?'40px':''}"></div>
    <!-- 搜索 -->
    <div class="search">
      <div class="search-content">
        <search background="#fff" @search="search" placeholder="搜索职位或公司">
          <!-- <template v-slot:left>
            <div class="city" @click="showCity = true;">{{queryData.city_names || '全国'}}<i class="iconfont iconchevron-down"></i></div>
          </template>
          <template v-slot:right>
            <div class="industry" @click="showIndustry = true;"><div class="text-overflow">行业领域</div><i class="iconfont iconchevron-down"></i></div>
          </template> -->
        </search>
        <div class="tag">
          <div class="tag-name">热门搜索：</div>
          <div class="tag-menu" v-for="item in contSearch" :key="item" @click="search(item)">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="content">

      <div class="banner">
        <!-- <login/> -->
        <user-info :professionsData="professionsData"/>

        <template>
          <el-carousel height='344px' :class="{'onlyOne': banner.length < 2}">
            <el-carousel-item v-for="(item,index) in banner" :key="index" >
              <img v-if="!item.link" :src="item.image" alt="" @click="bannerClick(item, $event)">
              <a v-else :href="item.link" target="__blank" @click="bannerClick(item, $event)">
                <img :src="item.image" alt="">
              </a>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>

      <div class="recruitment_dynamic" v-if="is_student">
        <recruitmentPreach />
      </div>
      <div class="recruitment_dynamic" v-if="is_student">
        <recruitmentDynamic />
      </div>

      <jobs-nav style="margin-top:30px" :link="navbarLink" :border="true"/>

      <!-- <filtrate :queryData="queryData" :path="path" @select="filtrateSelect"/> -->

      <skeleton v-if="isShowLoading" class="margin-t-16" :options="{moduleCount: 2, count: 4}"/>
      <div v-else-if="name==='JobsList'" class="list margin-t-16"  >
        <item-card
          v-for="(item, index) in data"
          :key="index"
          :data="item"
          class="list-item" />
      </div>
      <div v-if="personInfo.is_student === true && name==='JobsList1'" class="list margin-t-16" >
        <category/>
      </div>
      <a class="more-btn" :href="name==='JobsList'?'/jobs/search':'/campus_recruiting/search'" target="_blank">查看更多职位</a>
      <jobs-nav style="margin-top:24px" :link="[ { url: '', name: '热门企业', active: true} ]" :border="true"/>
      <skeleton v-if="isShowLoading" class="margin-t-16" :options="{moduleCount: 2, count: 4}"/>
      <div v-else class="list margin-t-16">
        <company-card
          v-for="(item, index) in companyData"
          :key="index"
          :data="item"
          :showPhase="true"
          class="list-card"/>
      </div>
      <a class="more-btn" href="/company" target="_blank">查看更多企业</a>
    </div>
    <alert :alertData="alertData" @close="alertClose" />
    <AdvertisingBoard />
    <pc-footer/>
   </div>
</template>
<script>
import recruitmentDynamic from './components/recruitmentDynamic';
import recruitmentPreach from './components/recruitmentPreach';
import category from './components/category';
import PcNavbar from '@/components/base/navbar';
import PcFooter from '@/components/base/pcFooter';
// import ItemList from './components/itemList';
import ItemCard from './components/itemCard';
import companyCard from '@/views/company/components/item';
// import CompanyCard from './components/companyCard';
import JobsNav from './components/jobsNav';
// import Filtrate from './components/filtrate'
import Search from '@/components/search';
import AdvertisingBoard from './components/AdvertisingBoard'
// import Login from './components/login';
// import City from './components/city';
// import Industry from './components/industry';
import UserInfo from './components/userInfo';
import api from '@/api';
import conditions from '@/assets/json/conditions';
import skeleton from '@/components/base/skeleton';
import { get_tUser, dealSignatrue, routerTo, auth, displayBannerSaveHistory } from '@/assets/js/util';
import alert from '../cvs/components/alert.vue'
import { mapState, mapActions } from 'vuex';
import {getOnlineCv} from "@/api/list/cvsV2";
const size = 18;
// 获取城市
const getCity = async () => {
  let res1 = await api.recruit.toObtainCityNew({nums:0,job_count:10});
  let city = []
  Object.keys(res1.data).forEach((key,index)=>{
    let obj ={}
    obj.group_name = key=='hot_cities'?'热门城市':key;
    obj.part_cities = res1.data[key].map(item=>{
      item.id= item.city_id
      return item
    })
    city.push(obj)
  })
  let cities = city || [];
  let hot_cities = res1.data.hot_cities || [];
  hot_cities.unshift({city_name: '全国', id: 0});
  cities[0] = {group_name: '热门城市', part_cities: hot_cities};
  return cities;
}
export default {
  layout: 'main',
  components: {
    PcNavbar,
    PcFooter,
    companyCard,
    // ItemList,
    ItemCard,
    JobsNav,
    Search,
    AdvertisingBoard,
    // page,
    // Filtrate,
    // Login,
    // City,
    // Industry,
    UserInfo,
    skeleton,
    category,
    recruitmentDynamic,
		recruitmentPreach,
    alert
  },
  data() {
    return {
      _c_t: '',
      contSearch: [ 'JAVA开发工程师', '产品经理','用户运营','市场营销','人事行政' ],
      queryData: {},
      data: [],
      companyData:[],
      showCity: false, // 显示城市弹窗
      showIndustry: false, // 显示行业弹窗
      banner: [],
      isShowLoading: true, // 显示加载条
      navbarLink: [ { url: '/jobs/recommend', name: '推荐职位', active: true},{ url: '/campus_recruiting/user_show', name: '校招网申', active: false} ],
      name:'',//推荐or网申
      defaultBanner: { image: 'https://files.wondercv.com/pcvue/banner.png', link: '/jobs/search?source=jd'},
      identity: '',  // 用户身份
      professionsData: [], // 树形职位类型
      is_student: true,
      alertData: {}
    };
  },
  computed: {
    ...mapState('me', ['personInfo']),
    ...mapState('global', ['nonChrome']),
    ...mapState('cv', ['onlineCvData'])
  },
  created () {
    this.change()
    // 获取树形职位类型
    this.getProfessionsTree();
    this._c_t = get_tUser().c_t || '';
    if (!this._c_t) {
      window.location.href = '/jobs/';
      return false;
    }
    this.getIdentity().finally(() => {
      this.getBanner()
    })
    this.getUserInfos();

    this.getCvsList()
  },
  watch: {
    personInfo(personInfo) {
      if (personInfo.is_student) {
        this.navbarLink = [ { url: '/jobs/recommend', name: '推荐职位', active: this.name === 'JobsList'}, { url: '/campus_recruiting/user_show', name: '校招网申', active: this.name === 'JobsList1',  } ];
      }else {

         this.navbarLink = [ { url: '/jobs/recommend', name: '推荐职位', active: this.name === 'JobsList'},  ];
      }
    }
  },
  async mounted() {
    this.displayImageBanner();
    this.$store.dispatch('app/setNavbarAction', '名企热招');
    // this._c_t = get_tUser().c_t || '';
    // if (!this._c_t) {
    //   window.location.href = '/jobs/';
    //   return false;
    // }
    // 获取用户在线简历
    await this.getOnlineCvData(this._c_t)
    await this.getJobs()
  },
  methods: {
    ...mapActions('cv', ['getOnlineCvData', 'getCvsList']),
    alertClose() {
      this.alertData.show = false;
    },
    // 获取用户信息
    getUserInfos() {
      api.account.getUserCvPublic(get_tUser()["c_t"]).then(res => {
        this.is_student = res.data.is_student;
      }).catch(err => Promise.reject(err));
    },
    // 获取身份
    async getIdentity() {
      try {
        let res = await api.cvsV2.getIdentifyInfo(this._c_t)
        if (res.code === 1000) {
          this.identity = res.data.status
          return Promise.resolve()
        } else {
          return Promise.reject()
        }
      } catch (e) {
        return Promise.reject()
      }
    },
    // 获取 banner 图
    async getBanner() {
      // banner
      try {
        let res = await api.jobs.getBanner({position: '0'});
        if (res.code === 1000) {
          this.banner = res.data;
          // this.banner = [{
          //   link: 'https://',
          //   deliver_channel: '123'
          // }];
        }
      } catch (e) {
        console.log(e)
      }
    },
    async displayImageBanner() {
      try {
        const { data, code } = await api.jobs.getBanner({ position: 130 });
        if (code === 1000) {
          const afterMinus = await displayBannerSaveHistory(data?.length, 'recommendJobsBanner');
          if (afterMinus === 0 || afterMinus) {
            this.alertData = {
              show: true,
              type: 'cvsguanggao',
              image: data[afterMinus],
            }
          }
        }
      } catch (error) {
        console.error(`display image banner is error: ${error}`)
      }
    },
    async getJobs() {
      // let onlineCv = await api.cvsV2.getOnlineCv(get_tUser().c_t || '')
      // let token=''
      // if(onlineCv.code===1000){
      //   token = onlineCv.data.token||""
      // }
      // 推荐职位

      let [res, res1] = await Promise.all(
        [api.recommend.jobListToJob({
          size: 9,
          page: 1,
          resume_token: this.onlineCvData ? this.onlineCvData.token : '',
        // resume_flag:1,
        // resume_token:token
      }),
          api.cvsV2.jobsPageCompany({
        page: 1,
        size: 8
      })])
      if(res.code === 1000){
        this.data = res.data.jobs || [];
      }
      if(res1.code === 1000){
        this.companyData = res1.data.companies || [];
      }
      this.isShowLoading = false;

    },
    filtrateSelect(data) {
      console.log(data);
    },
    search(value) {
      routerTo(`/jobs/search?keyword=${value || ''}`, '_blank');
    },
    //切换推荐和网申
    change() {
      this.name = this.$route.name
      if (this.name === 'JobsList') {
        this.navbarLink[0].active = true
        this.navbarLink[1].active = false
      } else {
        this.navbarLink[0].active = false
        this.navbarLink[1].active = true
      }
    },
    //获取树形结构的职位类型
    getProfessionsTree(){
      api.staticApi.getProfessionsTree().then(res=>{
        if(res.code === 1000){
          this.professionsData = res.data;
        }
      })
    },
    // banner点击
    bannerClick(banner, event){
      let { deliver_channel, job_infos=[], title } = banner
      if(deliver_channel){
        let jobToken = job_infos.length ? job_infos[0].token : '';
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'aliJobDelivery',
          deliveryJobOptions: {
            jobToken: jobToken,
            title: title
          }
        });
        // 阻止默认跳转
        event.preventDefault()
        return
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  @import './list.scss';
</style>
